import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useEffect, useState } from "react";
import styles from "../../RFPDashboard/RecceApproval/rfp.module.css";
import RecceReport from "../../RFPDashboard/RecceApproval/RecceReport.js";
import generatePaintingPPT from "./generatePaintingPPT.js";
import {
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Tooltip,
  Grid,
  Tabs,
  Paper,
  Divider,
  Button,
  Tab,
  Typography,
  Card,
  CircularProgress,
  CardContent,
} from "@mui/material";
import moment from "moment";
import StorefrontIcon from "@mui/icons-material/Storefront";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import FormatPaintIcon from "@mui/icons-material/FormatPaint";
import Swal from "sweetalert2";

const TribalArt = ({
  isModalOpen,
  setIsModalOpen,
  CampaignDetails,
  getCampaignDetails,
  selectedJob,
}) => {
  const [open, setOpen] = useState(false);
  const [currentReportType, setCurrentReportType] = useState(null);
  const [reportData, setReportData] = useState(null);
  const handleCloseModal = () => setIsModalOpen(false);
  const [tab, setTab] = useState(0);
  const [isPdfLoading, setIsPdfLoading] = useState(true);

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };
  const serverURL = process.env.REACT_APP_URL;
  const token = localStorage.getItem("token");

  const getApprovalData = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/installationPartnerJobApproval/viewJobApproval/${selectedJob._id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response?.data?.success) {
        setReportData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching campaign:", error);
    }
  };

  useEffect(() => {
    if (selectedJob) {
      getApprovalData();
    }
  }, [selectedJob]);

  const handleReportOpen = (fileType) => {
    setCurrentReportType(fileType);
    setOpen(true);
  };

  const files = [
    // {
    //   index: 1,
    //   name: "3D Renders",
    //   type: ".DWG",
    //   size: "7.5GB",
    //   modified: reportData?.job?.dateOnWhichJobCompleted
    //     ? moment(reportData.job.dateOnWhichJobCompleted).format("DD MMM YYYY")
    //     : "—",
    //   img: "/assests/images/Campaigndash/report1.png",
    //   fileType: "3d-renders",
    // },
    {
      index: 2,
      name: "Recce Report",
      type: "DOC",
      size: "1.2GB",
      modified: reportData?.job?.dateOnWhichJobCompleted
        ? moment(reportData.job.dateOnWhichJobCompleted).format("DD MMM YYYY")
        : "—",
      img: "/assests/images/Campaigndash/report2.png",
      fileType: "recce-report",
    },
    {
      index: 3,
      name: "Installation Images",
      type: "JPG/PNG",
      size: "1.4GB",
      modified: reportData?.job?.dateOnWhichJobCompleted
        ? moment(reportData.job.dateOnWhichJobCompleted).format("DD MMM YYYY")
        : "—",
      img: "/assests/images/Campaigndash/report1.png",
      fileType: "installation-images",
    },
    {
      index: 4,
      name: "Recce Images",
      type: "JPG/PNG",
      size: "1.4GB",
      modified: reportData?.job?.dateOnWhichJobCompleted
        ? moment(reportData.job.dateOnWhichJobCompleted).format("DD MMM YYYY")
        : "—",
      img: "/assests/images/Campaigndash/report3.png",
      fileType: "recce-images",
    },
    {
      index: 5,
      name: "Painting Images",
      type: "JPG/PNG",
      size: "1.4GB",
      modified: reportData?.job?.dateOnWhichJobCompleted
        ? moment(reportData.job.dateOnWhichJobCompleted).format("DD MMM YYYY")
        : "—",
      img: "/assests/images/Campaigndash/report3.png",
      fileType: "painting-images",
    },
  ];

  const handleRework = async (productId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "This will move job to rework",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#22c55e",
        cancelButtonColor: "#ef4444",
        confirmButtonText: "Yes, Rework",
        didOpen: () => {
          const swal = document.querySelector(".swal2-container");
          if (swal) swal.style.zIndex = "999999";
        },
      });

      if (!result.isConfirmed) return;

      const token = localStorage.getItem("token");

      await axios.patch(
        `${process.env.REACT_APP_URL}/jobs/rework`,
        {
          productId: productId,
          serviceType: "1", // 🔥 hardcoded installation
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // ✅ success message
      await Swal.fire({
        icon: "success",
        text: "Job moved to rework successfully",
        timer: 1500,
        showConfirmButton: false,
        didOpen: () => {
          const swal = document.querySelector(".swal2-container");
          if (swal) swal.style.zIndex = "999999";
        },
      });

      // 🔄 refresh UI
      await getCampaignDetails();

      setOpen(false);
      setIsModalOpen(false);
    } catch (err) {
      console.log(err);

      Swal.fire({
        icon: "error",
        text: "Something went wrong",
        didOpen: () => {
          const swal = document.querySelector(".swal2-container");
          if (swal) swal.style.zIndex = "999999";
        },
      });
    }
  };

  const renderReportComponent = () => {
    switch (currentReportType) {
      case "recce-images":
        return (
          <Box className="mt-0">
            <Grid container>
              <Grid item xs={12}>
                {/* Campaign Title */}
                <h3 className="text-3xl font-semibold mb-2">
                  {CampaignDetails?.data?.campaignTitle || "Untitled Campaign"}
                </h3>

                {/* Main Image */}
                <div>
                  {/* Main Image Heading */}
                  {/* <h4 className="text-lg font-medium mb-4 mt-5">Main Image</h4> */}

                  {/* Main Image */}
                  <img
                    loading="eager"
                    src={
                      reportData?.job?.imageOfRecceSpace ||
                      "/assests/AdminDashboard/dummyImageForNoImage.jpg"
                    }
                    alt="Recce Main"
                    className={`${styles.imageLogo} w-full h-auto rounded-lg border-2 border-solid mt-4`}
                  />
                </div>
              </Grid>
              {/* <Grid item xs={12} md={4} lg={3}>
                <Grid container spacing={2} direction="column">
                  {[
                    { key: "frontPhoto", label: "Front View" },
                    { key: "leftPhoto", label: "Left View" },
                    { key: "rightPhoto", label: "Right View" },
                  ].map(({ key, label }, idx) => (
                    <Grid item key={idx}>
                      <h4 className="text-base font-medium mb-1">{label}</h4>

                      <img
                        className={`${styles.imageLogo} w-full h-auto rounded-lg border-2 border-solid `}
                        loading="eager"
                        src={
                          reportData?.job?.storeImagesDuringRecce?.[key] ||
                          "/assests/AdminDashboard/dummyImageForNoImage.jpg"
                        }
                        alt={`Recce ${label}`}
                        style={{
                          width: "auto",
                          height: "auto",
                          maxHeight:
                            window.innerWidth < 600
                              ? "147px"
                              : window.innerWidth < 960
                              ? "108px"
                              : "132px",
                          borderRadius: "8px",
                          objectFit: "contain",
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid> */}
            </Grid>
          </Box>
        );
      case "recce-report":
      case "completion-report":
        return (
          <RecceReport
            setOpen={setOpen}
            open={open}
            timelineJobId={selectedJob?._id}
            actionButton={false}
          />
        );
case "installation-images":
  return (
    <Box className="mt-0">
      <Grid container>
        <Grid item xs={12}>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-3xl font-semibold mb-0">
              {CampaignDetails?.data?.campaignTitle ||
                "Untitled Campaign"}
            </h3>
            <button
              onClick={() => handleRework(selectedJob?.productId)}
              className="
                mr-12
                px-4 py-2
                rounded
                bg-green-400
                text-white
                hover:bg-green-500
                disabled:bg-gray-300
              "
            >
              Rework
            </button>
          </div>
          <div>
            <img
              loading="eager"
              src={
                reportData?.job?.imagesOfInstallation?.frontPhoto ||
                "/assests/AdminDashboard/dummyImageForNoImage.jpg"
              }
              alt="Installation Main"
              className={`${styles.imageLogo} w-full aspect-[3/2] h-auto rounded-lg border-2 border-solid mt-4`}
            />
          </div>
          {reportData?.job?.updatedBy && (
            <div className="mt-4 p-3 bg-indigo-50 rounded-lg border border-indigo-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-indigo-500 flex items-center justify-center text-white text-sm font-medium">
                   {reportData?.job?.updatedBy?.name?.charAt(0)?.toUpperCase() || " "}
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="text-sm font-semibold text-gray-800">
                        {reportData.job.updatedBy.name || "Unknown"}
                      </p>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-700">
                        {reportData.job.updatedBy.role === -1
                          ? "Super Admin"
                          : "CSM"}
                      </span>
                    </div>
                    {reportData?.job?.updatedAt && (
                      <p className="text-xs text-gray-400">
                        Updated: {moment(reportData.job.updatedAt).format("DD MMM YYYY, hh:mm A")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {reportData?.job?.installationRemark ? (
            <div className="mt-3 p-3 bg-blue-50 rounded-lg border border-blue-200">
              <div className="flex items-start">
                <div className="flex-1">
                  <p className="text-lg font-medium text-gray-700 mb-1"> Installation Remark:
                  </p>
                  <p className="text-sm text-gray-700">
                    {reportData?.job?.installationRemark}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            reportData?.job?.updatedBy && (
              <div className="mt-3 p-3 bg-gray-50 rounded-lg border border-gray-200">
                  <p className="text-sm text-gray-400 text-center">
                  No installation remark added
                </p>
              </div>
            )
          )}
        </Grid>
      </Grid>
    </Box>
  );
  case "painting-images":
        const paintingImages =
          reportData?.job?.paintingJobRelatedFields?.paintingImages || [];
        return (
          <Box
            sx={{
              p: 3,
              maxWidth: 1000,
              mx: "auto",
              bgcolor: "background.paper",
              borderRadius: 2,
            }}
          >
            {/* Header Section */}
            <Box sx={{ mb: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{ fontWeight: 700, color: "text.primary" }}
                >
                  {CampaignDetails?.data?.campaignTitle || "Campaign Details"}
                </Typography>

                <Button
                  variant="contained"
                  onClick={() => {
                    generatePaintingPPT({
                      CampaignDetails,
                      jobs: [...(reportData ? [reportData.job] : [])],
                    });
                  }}
                >
                  Download PPT
                </Button>
              </Box>

              <Grid container spacing={2}>
                {[
                  {
                    label: "Store Name",
                    value: selectedJob?.storeName,
                    icon: <StorefrontIcon fontSize="small" />,
                  },
                  {
                    label: "Product Type",
                    value: selectedJob?.productType,
                    icon: <ColorLensIcon fontSize="small" />,
                    isBlue: true,
                  },
                  {
                    label: "Painted Area",
                    value: `${reportData?.job?.paintingJobRelatedFields?.totalPaintedArea || "N/A"} sq.ft.`,
                    icon: <FormatPaintIcon fontSize="small" />,
                  },
                ].map((item, idx) => (
                  <Grid item xs={12} sm={4} key={idx}>
                    <Paper
                      variant="outlined"
                      sx={{ p: 1.5, borderRadius: 2, bgcolor: "#f8f9fa" }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 0.5,
                        }}
                      >
                        {item.icon}
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ fontWeight: 600, uppercase: true }}
                        >
                          {item.label}
                        </Typography>
                      </Box>
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 700,
                          color: item.isBlue ? "primary.main" : "text.primary",
                        }}
                      >
                        {item.value || "N/A"}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>

            <Tabs
              value={tab}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                mb: 3,
                borderBottom: 1,
                borderColor: "divider",
                "& .MuiTab-root": {
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: "1rem",
                },
              }}
            >
              <Tab label="Images" />
              <Tab label="Video" />
              <Tab label="PDF" />
              {/* <Tab label="Total Painted Area" /> */}
            </Tabs>

            {/* Tab Panels */}
            <Box sx={{ minHeight: 400 }}>
              {/* Images Tab */}
              {tab === 0 && (
                <Grid
                  container
                  spacing={2}
                  sx={{
                    maxHeight: 500,
                    overflowY: "auto",
                    pr: 1,
                    "&::-webkit-scrollbar": { width: "6px" },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#ccc",
                      borderRadius: "10px",
                    },
                  }}
                >
                  {paintingImages.length > 0 ? (
                    paintingImages.map((src, i) => (
                      <Grid item xs={6} md={4} key={i}>
                        <Card
                          sx={{
                            borderRadius: 3,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                              transform: "translateY(-4px)",
                              boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                            },
                            overflow: "hidden",
                            border: "1px solid #eee",
                          }}
                        >
                          <Box
                            component="img"
                            src={src}
                            alt={`Installation ${i}`}
                            sx={{
                              width: "100%",
                              height: 180,
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                        </Card>
                      </Grid>
                    ))
                  ) : (
                    <Box sx={{ textAlign: "center", width: "100%", py: 5 }}>
                      <Typography color="text.secondary">
                        No images uploaded for this campaign.
                      </Typography>
                    </Box>
                  )}
                </Grid>
              )}

              {/* Video Tab */}
              {tab === 1 && (
                <Card
                  variant="outlined"
                  sx={{ borderRadius: 3, overflow: "hidden" }}
                >
                  <Box
                    component="video"
                    controls
                    sx={{
                      width: "100%",
                      aspectRatio: "16 / 9", // Maintains a standard widescreen shape
                      display: "block",
                      bgcolor: "#000",
                      borderRadius: 2,
                      objectFit: "contain", // Ensures the full video is visible without cropping
                    }}
                  >
                    <source
                      src={
                        reportData?.job?.paintingJobRelatedFields?.paintVideo
                      }
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </Box>
                </Card>
              )}

              {/* PDF Preview Container */}
              {tab === 2 && (
                <Box sx={{ width: "100%", mt: 2, position: "relative" }}>
                  <Paper
                    variant="outlined"
                    sx={{
                      borderRadius: 3,
                      overflow: "hidden",
                      height: "750px",
                      bgcolor: "#f0f0f0", // Lighter bg for better image visibility
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {/* Loading Overlay */}
                    {isPdfLoading && (
                      <Box
                        sx={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          bgcolor: "rgba(255, 255, 255, 0.8)",
                          zIndex: 2,
                        }}
                      >
                        <CircularProgress size={40} sx={{ mb: 2 }} />
                        <Typography variant="body2" color="text.secondary">
                          Loading Preview...
                        </Typography>
                      </Box>
                    )}

                    {/* Conditional Rendering based on file type */}
                    {reportData?.job?.paintingJobRelatedFields?.signedDocument
                      ?.toLowerCase()
                      .endsWith(".pdf") ? (
                      <iframe
                        src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                          reportData?.job?.paintingJobRelatedFields
                            ?.signedDocument,
                        )}&embedded=true`}
                        title="PDF Preview"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                        onLoad={() => setIsPdfLoading(false)}
                      />
                    ) : (
                      <Box
                        component="img"
                        src={
                          reportData?.job?.paintingJobRelatedFields
                            ?.signedDocument
                        }
                        alt="Document Preview"
                        sx={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                        }}
                        onLoad={() => setIsPdfLoading(false)}
                        onError={() => setIsPdfLoading(false)} // Stop loading if image fails
                      />
                    )}
                  </Paper>
                </Box>
              )}
            </Box>
          </Box>
        );
      default:
        return (
          <div className="text-gray-600">
            Preview not available for this file type.
          </div>
        );
    }
  };

  return (
    <div>
      {/* Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-gray-800 bg-opacity-80 flex items-center justify-center z-50 shadow-xl"
          onClick={handleCloseModal}
        >
          {/* Modal Content */}
          <div
            className="bg-white w-[80%] lg:w-[60%] rounded-lg shadow-lg p-6 relative"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              onClick={handleCloseModal}
            >
              <CloseIcon /> {/* Cross Icon */}
            </button>

            {/* Modal Header */}
            <h2 className="text-2xl font-bold mb-4">
              {CampaignDetails?.data?.campaignTitle}
            </h2>

            {/* File Details Table */}
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="border-b text-gray-500">
                    <th className="py-2 px-4">File Name</th>
                    <th className="py-2 px-4">Type</th>
                    {/* <th className="py-2 px-4">Size</th> */}
                    {/* <th className="py-2 px-4">Last Modified</th> */}
                    <th className="py-2 px-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {files.map((file, index) => {
                    const hasRecceImage = !!reportData?.job?.imageOfRecceSpace;

                    const hasInstallationImage =
                      !!reportData?.job?.imagesOfInstallation?.frontPhoto;

                    const isInstallationBlocked =
                      !hasInstallationImage || reportData?.job?.rework;

                    const hasPaintingCompleted =
                      reportData?.job?.paintingJobRelatedFields
                        ?.paintingJobCompleted;

                    let isDisabled = false;
                    let tooltipMessage = "";

                    // Recce related files

                    if (
                      file.name === "Recce Report" ||
                      file.name === "Recce Images"
                    ) {
                      if (!hasRecceImage) {
                        isDisabled = true;
                        tooltipMessage = "Recce not done yet";
                      }
                    }

                    // Installation related file

                    if (file.name === "Installation Images") {
                      if (isInstallationBlocked) {
                        isDisabled = true;

                        if (reportData?.job?.rework) {
                          tooltipMessage =
                            "Installation images are unavailable because the job is in rework";
                        } else {
                          tooltipMessage = "Installation not done yet";
                        }
                      }
                    }

                    if (file.name === "Painting Images") {
                      if (!hasPaintingCompleted) {
                        isDisabled = true;
                        tooltipMessage = "Painting not done yet";
                      }
                    }

                    return (
                      <tr key={index} className="border-b text-gray-400">
                        {/* File Name */}
                        <td className="py-2">
                          <div className="flex">
                            <img src={file.img} alt="img" className="mr-2" />
                            <span>{file.name}</span>
                          </div>
                        </td>

                        {/* File Type */}
                        <td className="py-2 px-4">
                          <span className="border border-gray-400 p-1 bg-gray-200 rounded-md">
                            {file.type}
                          </span>
                        </td>

                        {/* Action */}
                        <td className="py-2 px-4">
                          <div className="flex items-center gap-2">
                            <Tooltip
                              title={tooltipMessage}
                              arrow
                              disableHoverListener={!isDisabled}
                            >
                              <span>
                                <button
                                  disabled={isDisabled}
                                  onClick={() =>
                                    handleReportOpen(file.fileType)
                                  }
                                  className={
                                    isDisabled
                                      ? "text-gray-400 cursor-not-allowed"
                                      : "text-blue-500 hover:underline cursor-pointer"
                                  }
                                >
                                  View File
                                </button>
                              </span>
                            </Tooltip>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent sx={{ position: "relative", padding: 2 }}>
          {/* Close Button with better positioning */}
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          {renderReportComponent()}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TribalArt;
